// (function() {
// 	'use strict';
// 	$(document).ready(function() {
// 		// Typeahead
// 		$.typeahead({
// 			input: 'input[name="s"].search-field',
// 			minLength: 3,
// 			maxItem: 0,
// 			dynamic: true,
// 			group: {
// 				key: "category",
// 				template: function(item) {
// 					//console.log(item);
// 					var result 			= '';
// 					var category_shown	= 0;
// 					console.log(category_shown);
// 					if ( item.category == 'Titel' && category_shown == 0 ) {
// 						console.log(item.category);
// 						var result += '<div class="">' + item.category + '</div>';
// 						category_shown	= 1;
// 					}



// 					var result +=
// 					'<span class="group">' +
// 						item.category +
// 						'<span class="count">(' +
// 							item.category_count +
// 						')</span>' +
// 					'</span>';
// 					if (item.category_link && item.category_link.length > 0) {
// 						// result +=
// 						// '<a class="show-all" href="' + item.category_link + '" title="Alle anzeigen">' +
// 						// 	'<span class="d-none d-sm-inline-block">' +
// 						// 		'Alle anzeigen' +
// 						// 	'</span>' +
// 						// '</a>';
// 					}
// 					return result;
// 				}
// 			},
// 			source: {
// 				category: {
// 					filter: false,
// 					// Array of Objects / Strings
// 					ajax: {
// 						url: "/ajax/search",
// 						type: "post",
// 						data: {
// 							"input": "{{query}}"
// 						}
// 					}
// 				}
// 			},
// 			delay: 100,
// 			searchOnFocus: true,
// 			// mustSelectItem: true,
// 			template: '<span class="result">{{display}}</span>',
// 			emptyTemplate: function (query) {
// 				if (query.length > 0) {
// 					return '<span title="Keine Treffer">Keine Treffer für „' + query + '“</span>';
// 				}
// 			},
// 			callback: {
// 				onClick: function (node, a, item, event) {
// 					window.location = item.link;
// 				},
// 				onLayoutBuiltBefore: function (node, query, result, resultHtmlList) {
// 					if (resultHtmlList && result.length > 0) {
// 						return resultHtmlList.append(
// 							$('<li />', { "class": "typeahead__item"}).append(
// 								$('<a/>', {
// 									"text": "Alle Treffer für „" + query + "“ anzeigen",
// 									"href": "/suche?s=" + query
// 								})
// 							)
// 						);
// 					}
// 				},
// 				onLayoutBuiltAfter: function () {
// 					$('.typeahead__item').last().addClass('active');
// 				}
// 			}
// 		});
// 		// Load next via ajax
// 		$('.search-results').wh_ajax_loader({
// 			auto_load			: false,
// 			loading_html 		: spinner,
// 			nav_selector		: '.load-next',
// 			next_selector		: '.load-next .btn',
// 			url_attribute		: 'data-next-url'
// 		});
// 	});
// }());